import { useAuth } from "@/_core/hooks/useAuth";

export default function ProtectedRoute({ component: Component, adminOnly }: { component: React.ComponentType<any>; adminOnly?: boolean }) {
  const { user, loading } = useAuth({ redirectOnUnauthenticated: true });

  if (loading || !user) {
    return null;
  }

  if (adminOnly && user.role !== "admin") {
    return null;
  }

  return <Component />;
}
